import { RequisiteP2PTransactionResult } from '../types/TransactionResult'
import api from './api'

export const payP2PConfirm = async (
    paymentPageId: string,
    transactionId: number,
): Promise<RequisiteP2PTransactionResult> => {
    return await api('/api/payment-page/pay/p2p/confirm', {
        paymentPageId: paymentPageId,
        transactionId: transactionId,
    }) as RequisiteP2PTransactionResult
}
